import { IDictionary } from "../Interfaces/IDictionary";
import ILanguage from "../Interfaces/ILanguage";
import { en } from "./en";
import { sv } from "./sv";

export const Languages: IDictionary<ILanguage> = {
    "sv": sv,
    "en": en,
}